<template>
    <table class="table table--simple">
        <tbody>
            <tr v-for="(value, key, index) in data" :key="index">
                <th>
                    <slot name="header" :paramName="key">
                        {{ key }}
                    </slot>
                </th>
                <td>
                    <slot name="value" :paramValue="value">
                        {{ parseValue(value) }}
                    </slot>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    name: 'SimpleTable',
    props: {
        data: {
            type: Object,
            default: null
        },
        paramName: {
            type: String,
            default: null
        },
        paramValue: {
            type: String,
            default: null
        }
    },
    methods: {
        parseValue(value) {
            return value ? value : '---'
        }
    }
}
</script>
